var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefferalIconGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.90299 9.91596C7.80167 9.90583 7.68009 9.90583 7.56863 9.91596C5.15717 9.8349 3.24219 7.85913 3.24219 5.4274C3.24219 2.94502 5.24836 0.928711 7.74088 0.928711C10.2233 0.928711 12.2396 2.94502 12.2396 5.4274C12.2294 7.85913 10.3145 9.8349 7.90299 9.91596Z",
    stroke: "#949699",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.2528 2.95508C17.2185 2.95508 18.7991 4.54583 18.7991 6.50134C18.7991 8.41633 17.2792 9.97668 15.3845 10.0476C15.3035 10.0375 15.2123 10.0375 15.1211 10.0476",
    stroke: "#949699",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.83899 13.6543C0.387003 15.2957 0.387003 17.9706 2.83899 19.6019C5.62534 21.4662 10.195 21.4662 12.9813 19.6019C15.4333 17.9605 15.4333 15.2856 12.9813 13.6543C10.2051 11.8001 5.63548 11.8001 2.83899 13.6543Z",
    stroke: "#949699",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.207 19.1672C17.9365 19.0152 18.6255 18.7214 19.1929 18.2857C20.7736 17.1002 20.7736 15.1447 19.1929 13.9593C18.6357 13.5337 17.9568 13.25 17.2374 13.0879",
    stroke: "#949699",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefferalIconGray);
export default __webpack_public_path__ + "static/media/refferal_icon_gray.4d8454392d3ee4662ab0b1e115984306.svg";
export { ForwardRef as ReactComponent };